/* eslint-disable */
import React from 'react';
import { ReactComponent as BlueSvg } from './Log2Base2BlueLogo.svg';
import { ReactComponent as WhiteSvg } from './Log2Base2WhiteLogo.svg';
import { ReactComponent as GreySvg } from './Log2Base2GreyLogo.svg';
import { ReactComponent as TextSvg } from './Log2Base2TextLogo.svg';
// import { ReactComponent as SquareSvg } from './Log2base2Favicon.svg';
import { ReactComponent as TextWhiteSvg } from './Log2Base2TextWhiteLogo.svg';
import { ReactComponent as DarkModeSvg } from './Log2Base2DarkLogo.svg';
// import { ReactComponent as PartnerPlusSvg } from './Log2base2PartnerPlus.svg';

export default function SiteLogo() {
  return <BlueSvg />;
}

export function SiteWhiteLogo() {
  return <WhiteSvg />;
}

export function SiteGreyLogo() {
  return <GreySvg />;
}

export function SiteTextLogo() {
  return <TextSvg />;
}

export function SiteTextWhiteLogo() {
  return <TextWhiteSvg />;
}

export function SiteDarkModeLogo() {
  return <DarkModeSvg />;
}

// export function SiteSquareLogo() {
//   return <SquareSvg />;
// }

// export function PartnerPlusLogo() {
//   return <PartnerPlusSvg />;
// }
